/* eslint-disable filename-export/match-default-export */
// TODO: refactor to a custom hook instead of a component that returns null
import { useEffect, useCallback } from 'react';
import pt from 'prop-types';
import { captureException } from '@sentry/browser';

import { useGetSchemaSummary } from '@ion/api';

const GetSchemaSummary = ({
  cluster,
  earliestSeen,
  timeframeHours,
  setSchemaSummary,
  setReportsError,
  setLoadingSummary,
}) => {
  const timeframe = timeframeHours + ' hours';
  const [getSchemaSummary] = useGetSchemaSummary({
    onCompleted: r => {
      setSchemaSummary(r.summary);
    },
    onError: err => {
      captureException(err);
      setReportsError(err);
    },
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getSchemaSummaryCallback = useCallback(getSchemaSummary, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setLoadingSummaryCallback = useCallback(setLoadingSummary, []);

  useEffect(() => {
    if (!cluster) {
      return;
    }
    setLoadingSummaryCallback();
    getSchemaSummaryCallback({ clusterId: cluster.id, earliestSeen, timeframe });
  }, [cluster, earliestSeen, timeframe, setLoadingSummaryCallback, getSchemaSummaryCallback]);

  return null;
};

GetSchemaSummary.propTypes = {
  cluster: pt.shape({
    id: pt.string,
  }),
  earliestSeen: pt.string,
  timeframeHours: pt.number,
  setSchemaSummary: pt.func.isRequired,
  setReportsError: pt.func.isRequired,
  setLoadingSummary: pt.func.isRequired,
};

export default GetSchemaSummary;
